import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div data-testid="page-not-found" className="py-32 text-center">
      <p className="eyebrow">Eroare 404</p>
      <h1 className="h-display text-5xl md:text-7xl text-text mt-4">Pagina nu există.</h1>
      <p className="mt-4 text-text-soft">Probabil s-a dospit altundeva. Hai înapoi.</p>
      <Link to="/" className="mt-8 inline-block">
        <Button className="btn-gold rounded-full h-12 px-7">Înapoi acasă</Button>
      </Link>
    </div>
  );
}
